import React, { Component } from "react";
import { Tab, Modal, Button, Icon, Header } from "semantic-ui-react";
import { getpath } from "../actions/get-path";
import { getAction } from "../actions/get-action";
import { bindActionCreators } from "redux";
import { app, store } from "../index";
import moment from "moment";
import { connect } from "react-redux";
import EditModal from "../components/accounting/editmodal";
import CreateInv from "../components/accounting/invoices/createinvoices";
import AnnualLedger from "../components/accounting/invoices/annualledger";
import { queryservice, grabservice, createservice, updateservice, deleteservice } from "../services/crudservice";
import { gendropdown, genwoddrop } from "../services/gendropdown";
import Roundy from "../services/roundy";
import { runinvoices } from "../services/geninvoices";
import InvoiceTable from "../components/accounting/invoices/invoicetable";
import UnpaidInv from "../components/accounting/invoices/unpaidinvoices";
import CustomInv from "../components/accounting/invoices/custominv";
import FixedInv from "../components/accounting/invoices/fixedinv";
import { datapop } from "../actions/data-populate";
import { newfeedback } from "../actions/feedback";
import PaidInv from "../components/accounting/invoices/paidinv";
class Invoices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoices: [],
      tnmids: [],
      unpaidInv: [],
      unaprovedInv: [],
      unsentInv: [],
      newinvoices: null,
      showEditModal: false,
      ledgerinfo: null
    };
  }

  componentDidMount() {
    grabservice("invoices").then(response => {
      console.log(response);
      this.populatestate(response);
    });
    this.props.getpath("Invoices", "visa");
  }
  init() {
    grabservice("invoices").then(response => {
      console.log(response);
      this.populatestate(response);
    });
  }
  populatestate(invoices) {
    let unpaid = [];
    let paid = []
    let unaproved = [];
    let unsent = [];
    invoices.map(invoice => {
      if (Roundy(invoice.paidamount) < Roundy(invoice.amount)) {
        unpaid.push(invoice);
      }
      if (invoice.approved === null) {
        unaproved.push(invoice);
      }
      if (invoice.submitdate === null) {
        unsent = unsent.concat(invoice);
      }
      if (Roundy(invoice.paidamount) >= Roundy(invoice.amount)) {
        paid = paid.concat(invoice)
      }
    });
    this.setState({
      unpaidInv: unpaid,
      paidInv: paid,
      unaprovedInv: unaproved,
      unsentInv: unsent,
      invoices: invoices
    });
  }
  componentDidUpdate(prevProps, prevState) {
    this.props.datapop("hradmin", "AccessRequest");
  }
  findinvindex(newinvs, wonumber) {
    return newinvs.findIndex(i => i.workordernumber === wonumber);
  }

  getledger() {
    return queryservice("reports", "report", "ledger").then(response => {
      console.log(response);
      this.setState({ ledgerinfo: response[0] });
      return response;
    });
  }
  genInvoicenumbers() {
    let customers = Array.from(this.props.customers);
    let invoices = this.state.newinvoices.map(inv => {
      if (inv.included) {
        let custindex = customers.findIndex(
          cust => cust.custnumber === inv.custnumber
        );
        let custinfo = Object.assign({}, customers[custindex]);
        inv = { ...inv, number: customers[custindex].nextinvnumber };
        custinfo.nextinvnumber = parseInt(custinfo.nextinvnumber) + 1;
        customers[custindex] = Object.assign({}, custinfo);
      }

      return inv;
    });
    this.setState({ newinvoices: invoices });
  }
  handleRunInvoices(enddate, startdate) {
    if (
      this.props.wods.length > 0 &&
      this.props.wods &&
      this.props.customers.length
    ) {
      runinvoices(enddate, this.props.wods, startdate).then(
        (invoices, tnmids) => {
          this.setState({ newinvoices: invoices });
        }
      );
    }
  }
  createinv(invoices) {
    app.service("invoices").create(invoices);
  }
  handleDelete(id) {
    app.service("invoices").remove(id);
  }
  handleEdit(id) {
    this.state.invoices.map(invoice => {
      if (invoice.id === id) {
        console.log("something");
        // this.setState({ editInv: invoice, showEditModal: true });
      }
    });
  }

  handleUpdate(id, invoice) {
    app.service("invoices").update(id, invoice);
  }
  // export const gendropdown = (key, text, value, array) => {

  handleDropSelect(value, param, storeprop, dropkey, droptext, dropvalue) {
    let temparray = [];
    this.props[storeprop].map(item => {
      if (item[param] === value) {
        temparray = temparray.concat(item);
      }
    });
    return gendropdown(dropkey, droptext, dropvalue, temparray);
  }
  renderInvoiceTable(ColSpan, Invoices, type) {
    if (this.props.customers.length > 0 && Invoices) {
      return (
        <InvoiceTable
          colspan={ColSpan}
          type={type}
          wods={this.props.wods}
          customers={this.props.customers}
          invoices={Invoices}
          handleDelete={id => {
            // I will make it a switch based on if invoice is an array or not

            this.handleDelete(id);
          }}
          markaspaid={invoice =>
            updateservice("invoices", invoice, invoice.id).then(() => {
              grabservice("invoices").then(response => {
                console.log(response);
                this.populatestate(response);
              });
            })
          }
          updatelist={(invindex, included) => {
            let invoices = this.state.newinvoices;
            invoices[invindex].included = included;
            this.setState(
              {
                newinvoices: invoices
              },
              () => this.genInvoicenumbers()
            );
          }}
          editPayment={payment => updateservice("payments", payment, payment.id).then(t => this.init())}
          deletePayment={payment => deleteservice("payments", payment.id).then(() => this.init())}
          newPayment={payment => createservice("payments", payment).then(t => this.init())}

          removeinv={invindex => {
            let invoices = this.state.newinvoices;
            invoices[invindex].included = false;
            this.setState(
              {
                newinvoices: invoices
              },
              () => this.genInvoicenumbers()
            );
          }}
          removeexisting={invoice => {
            app
              .service("invoices")
              .remove(invoice.id)
              .then(() => {
                grabservice("invoices").then(response => {
                  console.log(response);
                  this.populatestate(response);
                });
              });
          }}
          handleEdit={id => this.handleEdit(id)}
        />
      );
    }
  }
  render() {
    const panes = [
      {
        menuItem: "Create Invoices",
        render: () => (
          <div>
            <CreateInv
              runinvoices={date => {
                this.handleRunInvoices(date);
              }}
              newinvoices={this.state.newinvoices}
              createInv={() => {
                let invoices = this.state.newinvoices.filter(
                  inv => inv.included === true
                );
                console.log('Creating Invoices', invoices)
                app
                  .service("invoices")
                  .create(invoices)
                  .then(() => {
                    this.props.newfeedback({
                      color: "green",
                      icon: "check",
                      header: "Invoicing Success",
                      body: "Invoices Created Successfully"
                    });
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch(err =>
                    newfeedback({
                      color: "red",
                      icon: "warning",
                      header: "Invoice Failure",
                      body: err.message
                    })
                  );
              }}
            />
            {this.renderInvoiceTable("6", this.state.newinvoices, "create")}
          </div>
        )
      },
      {
        menuItem: "Custom Invoice",
        render: () => (
          <div>
            <CustomInv
              newinvoices={this.state.newinvoices}
              companyitems={this.state.companyitems}
              runinvoices={(startdate, enddate) => {
                this.handleRunInvoices(enddate, startdate);
              }}
              handleDelete={id => {
                this.handleDelete(id);
              }}
              createInv={() => {
                console.log("Invoice", this.state.newinvoices.filter(inv => inv.included === true))
                app
                  .service("invoices")
                  .create(
                    this.state.newinvoices.filter(inv => inv.included === true)
                  )
                  .then(response =>
                    store.dispatch(
                      newfeedback({
                        color: "green",
                        icon: "check",
                        header: "T&M Success",
                        body: "T & M Created Successfully"
                      })
                    )
                  )
                  .catch(err =>
                    store.dispatch(
                      newfeedback({
                        color: "red",
                        icon: "warning",
                        header: "Invoice Failure",
                        body: err.message
                      })
                    )
                  );
              }}
            />
            {this.renderInvoiceTable("6", this.state.newinvoices, "create")}
          </div>
        )
      },
      {
        menuItem: "Send Invoices",
        render: () => ({
          /*
          <div>
            <p>this would be send invoices</p>
           <SendInv
              invoices={this.state.invoices}
              handlesend={() => {
                let submitinv = [];
                this.state.unsentInv.map(inv => {
                  if (inv.submitdate) {
                    submitinv = submitinv.concat(inv.id);
                  }
                  app
                    .service("invoices")
                    .patch(
                      null,
                      { submitdate: moment().format("YYYY-MM-DD") },
                      { id: { $in: submitinv } }
                    );
                });
              }}
              handleDelete={id => {
                this.handleDelete(id);
              }}
              handleEdit={id => this.handleEdit(id)}
            />
            {this.renderInvoiceTable("6", this.state.unsentInv, "unsent")}
          </div>
          */
        })
      },
      {
        menuItem: "Customer Invoice",
        render: () => (
          <div>
            <p>this would be customer invoice</p>
            {/*  <CustomerInv
            custinvoices={this.state.custinvoices}
            handleDelete={id => {
              this.handleDelete(id);
            }}
            handleEdit={id => this.handleEdit(id)}
          /> */}
          </div>
        )
      },
      {
        menuItem: "Unpaid Invoices",
        render: () => (
          <div>
            <UnpaidInv
              invoices={this.state.unpaidInv}
              handleDelete={id => {
                // I will make it a switch based on if invoice is an array or not

                this.handleDelete(id);
              }}
              markaspaid={id =>
                app
                  .service("invoices")
                  .patch(id, { paiddate: moment().format("YYYY-MM-DD") })
              }
              handleEdit={inv => this.handleEdit(inv)}
              customers={this.props.customers}
            />
            {this.renderInvoiceTable("6", this.state.unpaidInv, "unpaid")}
          </div>
        )
      },
      {
        menuItem: "Paid Invoices",
        render: () => (
          <div>
            <PaidInv
              invoices={this.state.paidInv}
              handleDelete={id => {
                this.handleDelete(id);
              }}
              markaspaid={id =>
                app
                  .service("invoices")
                  .patch(id, { paiddate: moment().format("YYYY-MM-DD") })
              }
              handleEdit={inv => this.handleEdit(inv)}
              customers={this.props.customers}
            />
            {this.renderInvoiceTable("6", this.state.paidInv, "paid")}
          </div>
        )
      },
      {
        menuItem: "Fixed Price",
        render: () => (
          <div>
            <FixedInv
              invoices={this.state.invoices}
              customers={this.props.customers}
              wodoptions={genwoddrop(this.props.fixedwods)}
            />
          </div>
        )
      },
      {
        menuItem: "Annual Ledger",
        render: () => (
          <AnnualLedger
            ledgerinfo={this.state.ledgerinfo}
            getledger={() => this.getledger()}
          />
        )
      },
      <div>
        {/*
        <MassDelete

          deleteweeks={() => {
            return;
            queryservice("invoices", "description", "deletelist");
          }}
          handleDelete={invids => {
            invids.map(invid => {
              let invoice = this.state.invoices.find(inv => inv.id === invid);
              deleteservice("invoices", invid).then(response => {
                app.service("tmsheets").patch(
                  null,
                  { invoicenumber: null },
                  {
                    custnumber: response.custnumber,
                    invoicenumber: response.invoicenumber
                  }
                );
              });
            });
          }}
        />
        {this.renderInvoiceTable("6", this.state.newinvoices, "create")}
*/}
      </div>
    ];
    const tabs = [
      "create",
      "custom",
      "send",
      "customer",
      "unpaid",
      "paid",
      "fixedprice",
      "annual-ledger",
      "massdelete"
    ];
    return (
      <div className="Invoices">
        <Tab
          panes={panes}
          menu={{ secondary: true, pointing: true }}
          defaultActiveIndex={tabs.indexOf(this.props.params.tabindex)}
          onTabChange={(e, data) => { }}
        />

        <Modal open={this.state.showdeletemodal} basic size="small">
          <Header
            icon="archive"
            content="Are you sure you would like to delete these items?"
          />
          <Modal.Content>
            Are you sure you want to delete{" "}
            {this.state.deletetype + " " + this.state.deletenum}
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="red"
              inverted
              onClick={() => this.setState({ showdeletemodal: false })}
            >
              <Icon name="remove" /> No
            </Button>
            <Button
              color="green"
              inverted
              onClick={() => this.handledeleteitems()}
            >
              <Icon name="checkmark" /> Yes
            </Button>
          </Modal.Actions>
        </Modal>

        <EditModal type="Invoices" ref="editmodal" value={this.state.editInv} />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    fixedwods: state.workorders.fixedwods,
    wods: state.workorders.derivitives,
    customers: state.custinfo.customers,
    employees: state.employees,
    jobs: state.jobs.assignedjobs,
    dates: state.dates.thisweek,
    myinfo: state.myinfo.employeeinfo
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      newfeedback: newfeedback,
      datapop: datapop,
      getpath: getpath,
      get: getAction
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(Invoices);



// WEBPACK FOOTER //
// ./src/containers/Invoices.jsx